import type {
  PortfolioStudentSort,
  PortfolioStudentSortState,
  SortDirection,
} from "portfolio/types";

export const PORTFOLIO_STUDENT_SORT = {
  Name: "name",
  LastActivity: "last_activity",
} as const satisfies Record<string, PortfolioStudentSort>;

export const SORT_DIRECTION = {
  Asc: "asc",
  Desc: "desc",
} as const satisfies Record<string, SortDirection>;

export const DEFAULT_PORTFOLIO_STUDENT_SORT: PortfolioStudentSortState = {
  sort: PORTFOLIO_STUDENT_SORT.Name,
  order: SORT_DIRECTION.Asc,
};
